// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateEpmMasterFunctionalityMutationVariables = Types.Exact<{
  input: Types.UpdateEpmMasterFunctionalityInput;
}>;

export type UpdateEpmMasterFunctionalityMutation = { __typename?: 'Mutation' } & {
  updateEpmMasterFunctionality: { __typename?: 'EpmMasterFunctionalityOutput' } & Pick<
    Types.EpmMasterFunctionalityOutput,
    'id'
  >;
};

export const UpdateEpmMasterFunctionalityDocument = /*#__PURE__*/ gql`
    mutation updateEpmMasterFunctionality($input: UpdateEpmMasterFunctionalityInput!) {
  updateEpmMasterFunctionality(input: $input) {
    id
  }
}
    `;
export type UpdateEpmMasterFunctionalityMutationFn = Apollo.MutationFunction<
  UpdateEpmMasterFunctionalityMutation,
  UpdateEpmMasterFunctionalityMutationVariables
>;

/**
 * __useUpdateEpmMasterFunctionalityMutation__
 *
 * To run a mutation, you first call `useUpdateEpmMasterFunctionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpmMasterFunctionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpmMasterFunctionalityMutation, { data, loading, error }] = useUpdateEpmMasterFunctionalityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEpmMasterFunctionalityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEpmMasterFunctionalityMutation,
    UpdateEpmMasterFunctionalityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEpmMasterFunctionalityMutation, UpdateEpmMasterFunctionalityMutationVariables>(
    UpdateEpmMasterFunctionalityDocument,
    options,
  );
}
export type UpdateEpmMasterFunctionalityMutationHookResult = ReturnType<typeof useUpdateEpmMasterFunctionalityMutation>;
export type UpdateEpmMasterFunctionalityMutationOptions = Apollo.BaseMutationOptions<
  UpdateEpmMasterFunctionalityMutation,
  UpdateEpmMasterFunctionalityMutationVariables
>;
